import React from 'react'

import Loading from '../../../components/layout/Loading'
import { useI18N } from '../../../../libraries/i18n/hook'
import DocumentDetails from '../../../components/content/DocumentDetails'
import { useToaster } from '../../../../libraries/toaster'
import DocumentsCarousel from './Carousel'
import config from '../../../../config'
import PageSection from '../../../components/layout/PageSection'
import { useDocumentById, useMutateBookmarkDocument, useRelatedDocuments } from '../../../../hocs/content/useDocuments'

type Props = { id: string }
const Details: React.FC<Props> = ({ id }) => {
  const { showSuccess } = useToaster()
  const { t } = useI18N()
  const { data, isLoading, error, mutate: refreshDocumentData } = useDocumentById(id)
  const { trigger: submitBookmark } = useMutateBookmarkDocument(id)

  if(isLoading) return <Loading size='fill-container' />
  if(error) return <div>{t(`error.${error?.code}`)}</div>
  if(!data) return <div>This should not happen</div>

  const handleToggleBookmark = async () => {
    await submitBookmark({ saved: !data?.userActivity?.saved, documentId: id })
    refreshDocumentData()
    showSuccess(!data?.userActivity?.saved ? t('content.bookmarked.success') : t('content.unbookmarked.success'))
  }

  return (
    <>
      <DocumentDetails {...data} handleToggleBookmark={handleToggleBookmark} />
      <PageSection title={t('content.related')}>
        <DocumentsCarousel queryFn={() => useRelatedDocuments(data.id, config.VITE_MAX_CAROUSEL_ITEMS)} />
      </PageSection>
    </>
  )
}

export default Details
